import React__default from 'react';
import { Typography, Chip } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import SanitizeHtml from '../../SanitizeHtml/index.js';
import StyledNotFoundReference, { classes } from './index.styled.js';

var NotFoundReference = function (_a) {
    var _b;
    var _c = _a.references, references = _c === void 0 ? {
        notFound: [],
        found: [],
        all: []
    } : _c;
    var t = useTranslation("refront-components").t;
    var notFoundTranslation = t("components.notFoundReference.notFound.label", {
        notFound: (_b = references === null || references === void 0 ? void 0 : references.notFound) === null || _b === void 0 ? void 0 : _b.join(", ")
    });
    return (React__default.createElement(React__default.Fragment, null, references.notFound && references.notFound.length > 0 && (React__default.createElement(StyledNotFoundReference, { className: clsx("NotFoundReference") },
        React__default.createElement(Typography, { className: classes.caption, variant: "caption" }, t("components.notFoundReference.label")),
        React__default.createElement(Chip, { "data-testid": "notFoundReferenceTestId", size: "small", label: React__default.createElement("span", { title: "".concat(references.notFound.join(", ")) },
                React__default.createElement(SanitizeHtml, { html: notFoundTranslation })), className: classes.chipNotFound })))));
};

export { NotFoundReference as default };
//# sourceMappingURL=index.js.map
